import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { PurchaseOrder } from '../domain/purchaseOrder';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-purchase-orders',
  templateUrl: './purchase-orders.component.html',
  host: { "(window:keyup)": "hotkeys($event)" },
  styleUrls: ['./purchase-orders.component.css']
})
export class PurchaseOrdersComponent implements OnInit {
  confirmationDialogVisible = false;
  confirmationDialogMessage = '';
  private pendingOrderDeletion: { order: any; fulfilled: boolean } | null = null;
  @ViewChild("searchOrder", { static: false }) searchOrderInput: ElementRef;
  loading: boolean;
  user: IUser;
  purchaseOrder: PurchaseOrder;
  firstFulFilled: number = 0;
  firstUnFulFilled: number = 0;
  showCommentBox: boolean = false;
  tabIndex: number;
  purchases: any[];
  fulFilledPurchases: any[];
  fulFilledSourcePurchases: any[];
  unFulFilledPurchases: any[];
  unFulFilledSourcePurchases: any[];

  constructor(
    private LanguageService: LanguageService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Purchase Orders' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PurchaseOrdersComponent", label);
  }
  ngOnInit(): void {
    this.user = AuthService.getLoggedInUser();
    this.purchaseOrder = new PurchaseOrder();
    this.getPurchaseOrders();
    this.purchases = [];
    this.fulFilledPurchases = [];
    this.unFulFilledPurchases = [];
  }

  ngAfterViewInit() {
    this.searchOrderInput.nativeElement.focus();

  }

  getPurchaseOrders() {
    this.loading = true;
    this.appServiceManager.get(`branches/${this.user.branch}/purchase-orders`).subscribe((res: any) => {
      if (res.length > 0) {
        this.purchases = res;
        this.fulFilledPurchases = this.purchases.filter(x => x.status == 'FULFILLED');
        this.fulFilledSourcePurchases = this.fulFilledPurchases;
        this.unFulFilledPurchases = this.purchases.filter(x => x.status !== 'FULFILLED');
        this.unFulFilledSourcePurchases = this.unFulFilledPurchases;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
      this.clearFulfilled();
    }
    if (index == 1) {
      this.tabIndex = 1;
      this.clearUnfulfilled();
    }
  }

  searchLocalUnFulFilled(value, type) {
    let matchedNumber = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.unFulFilledPurchases = Object.assign([], this.unFulFilledSourcePurchases);
      }
      if (!value) {
        this.unFulFilledPurchases = Object.assign([], this.unFulFilledSourcePurchases);
      }
      if (value != "") {
        if (type === "number") {
          matchedNumber = Object.assign([], this.unFulFilledSourcePurchases).filter(
            cust => cust.purchaseOrderNumber ? cust.purchaseOrderNumber.indexOf(value) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedNumber;
        this.unFulFilledPurchases = source.filter(distinct);

        if (this.unFulFilledPurchases.length === 0) {
          this.unFulFilledPurchases = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.firstUnFulFilled = 0;
          if (this.unFulFilledPurchases.length === 1) {
            this.firstUnFulFilled = 0;
          }
          this.unFulFilledPurchases = [...this.unFulFilledPurchases];
        }
      }
    } else {
      this.unFulFilledPurchases = Object.assign([], this.unFulFilledSourcePurchases);
      this.unFulFilledPurchases = [...this.unFulFilledPurchases];
    }
  }

  searchLocalFulfilled(value, type) {
    let matchedNumber = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.fulFilledPurchases = Object.assign([], this.fulFilledSourcePurchases);
      }
      if (!value) {
        this.fulFilledPurchases = Object.assign([], this.fulFilledSourcePurchases);
      }
      if (value != "") {
        if (type === "number") {
          matchedNumber = Object.assign([], this.fulFilledSourcePurchases).filter(
            cust => cust.purchaseOrderNumber ? cust.purchaseOrderNumber.indexOf(value) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedNumber;
        this.fulFilledPurchases = source.filter(distinct);

        if (this.fulFilledPurchases.length === 0) {
          this.fulFilledPurchases = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.firstFulFilled = 0;
          if (this.fulFilledPurchases.length === 1) {
            this.firstFulFilled = 0;
          }
          this.fulFilledPurchases = [...this.fulFilledPurchases];
        }
      }
    } else {
      this.fulFilledPurchases = Object.assign([], this.fulFilledSourcePurchases);
      this.fulFilledPurchases = [...this.fulFilledPurchases];
    }
  }

  clearFulfilled() {
    this.purchaseOrder = new PurchaseOrder();
    this.searchLocalFulfilled("", "");
    this.firstFulFilled = 0;
  }

  clearUnfulfilled() {
    this.purchaseOrder = new PurchaseOrder();
    this.searchLocalUnFulFilled("", "");
    this.firstUnFulFilled = 0;
  }

  onFulfilledPageChange(event) {
    this.firstFulFilled = event.first;
  }

  onUnfulfilledPageChange(event) {
    this.firstUnFulFilled = event.first;
  }

  ShowCommentBox(order) {
    if (order.remarks != undefined) {
      this.showCommentBox = true;
      this.purchaseOrder.remarks = order.remarks;
    } else {
      return;
    }
  }

  viewPurchaseOrder(order) {
    this.route.navigateByUrl('purchase-order/' + order._id);
  }

  deleteFulfilledPurchaseOrder(order) {
    this.openOrderDeletionConfirmation(order, true);
  }

  deletePurchaseOrder(order) {
    this.openOrderDeletionConfirmation(order, order.status === 'FULFILLED');
  }

  deleteUnFulFilledPurchaseOrder(order) {
    this.openOrderDeletionConfirmation(order, false);
  }

  private openOrderDeletionConfirmation(order: any, fulfilled: boolean) {
    this.pendingOrderDeletion = { order, fulfilled };
    this.confirmationDialogMessage = "Are you sure you want to Delete?";
    this.confirmationDialogVisible = true;
  }

  cancelOrderDeletion() {
    this.confirmationDialogVisible = false;
    this.pendingOrderDeletion = null;
  }

  confirmOrderDeletion() {
    const pendingDeletion = this.pendingOrderDeletion;
    this.cancelOrderDeletion();
    if (!pendingDeletion) return;

    if (pendingDeletion.fulfilled) {
      this.executeFulfilledPurchaseOrderDeletion(pendingDeletion.order);
    } else {
      this.executeUnFulfilledPurchaseOrderDeletion(pendingDeletion.order);
    }
  }

  private executeFulfilledPurchaseOrderDeletion(order) {
        this.loading = true;
        let data = {
          modifiedBy: this.user._id
        };
        const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
        this.appServiceManager.delete(`branches/${branchId}/purchase-orders/${order._id}`, data).subscribe((res: any) => {
          if (res.status === true) {
            this.DeleteFulfilledPurchaseOrder(order);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.fulFilledPurchases = [...this.fulFilledPurchases];

        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
  }

  DeleteFulfilledPurchaseOrder(order) {
    let fulFilledPurchases = [...this.fulFilledPurchases];
    let index = this.fulFilledPurchases.indexOf(order);
    if (index > -1) {
      fulFilledPurchases.splice(index, 1);
      return this.fulFilledPurchases = fulFilledPurchases;
    }
  }

  private executeUnFulfilledPurchaseOrderDeletion(order) {
        this.loading = true;
        let data = {
          modifiedBy: this.user._id
        };
        const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
        this.appServiceManager.delete(`branches/${branchId}/purchase-orders/${order._id}`, data).subscribe((res: any) => {
          if (res.status === true) {
            this.DeleteUnFulfilledPurchaseOrder(order);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.unFulFilledPurchases = [...this.unFulFilledPurchases];

        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
  }

  DeleteUnFulfilledPurchaseOrder(order) {
    let unFulFilledPurchases = [...this.unFulFilledPurchases];
    let index = this.unFulFilledPurchases.indexOf(order);
    if (index > -1) {
      unFulFilledPurchases.splice(index, 1);
      return this.unFulFilledPurchases = unFulFilledPurchases;
    }
  }

  hotkeys($event) {
    if ($event.keyCode == 113) {
      this.route.navigateByUrl("/purchase-order");
    }

  }
}